import React, { useEffect } from "react";
import { useAuthStore } from "../store/auth.js";

export interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps): React.ReactElement {
  const { status, errorMessage, authenticate } = useAuthStore();

  useEffect(() => {
    if (status === "idle") {
      authenticate();
    }
  }, [status, authenticate]);

  if (status === "idle" || status === "loading") {
    return (
      <div
        data-testid="loading-screen"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "24px",
          fontFamily: "inherit",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "36px",
            height: "36px",
            border: "3px solid var(--color-frost-border)",
            borderTopColor: "var(--color-muted-gold)",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            marginBottom: "16px",
          }}
        />
        <p style={{ color: "var(--color-slate)", fontSize: "14px", margin: 0 }}>
          Авторизация в Telegram...
        </p>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div
        data-testid="error-screen"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "24px",
          textAlign: "center",
          fontFamily: "inherit",
        }}
      >
        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            backgroundColor: "var(--color-destructive-bg)",
            color: "var(--color-destructive)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "24px",
            marginBottom: "16px",
          }}
        >
          !
        </div>
        <h2 style={{ fontSize: "18px", fontWeight: 600, margin: "0 0 8px 0" }}>
          Ошибка авторизации
        </h2>
        <p style={{ color: "var(--color-slate)", fontSize: "14px", margin: "0 0 24px 0", maxWidth: "320px" }}>
          {errorMessage || "Не удалось войти в аккаунт. Попробуйте позже или обратитесь в поддержку."}
        </p>
        <button
          onClick={() => authenticate()}
          style={{
            padding: "12px 24px",
            backgroundColor: "var(--color-graphite)",
            color: "var(--color-paper)",
            border: "none",
            borderRadius: "12px",
            fontSize: "14px",
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Попробовать снова
        </button>
      </div>
    );
  }

  return <>{children}</>;
}
